import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/database';

@Injectable()
export class FirebaseService {
  ref: any;

  constructor() {
    this.ref = firebase.database().ref('geolocations/');
  }

  deleteDelivery(deliveryId: string): Promise<any> {
    return this.ref.child(deliveryId).remove();
  }
}
